import Weekdays from './Weekdays.jsx';
import './Weekdays.css';

export default Weekdays;
